export default __webpack_public_path__ + "static/media/logoNovusLight.4887db14.png";